// import { useState } from 'react';

import { usePresenterOrAttendee } from '../context/AttendeeAndPresenterProvider';
import { Button } from '@mui/material';

const buttonStyle = {
  width: 200,
  padding: 1
};

const Controls = () => {
  const {
    gameState,
    startGame,
    endGame,
    nextQuestion,
    closeQuestion,
    prevQuestion,
    openQuestion,
    resetGame,
    questionIds
  } = usePresenterOrAttendee();

  if (!gameState || !gameState.state) {
    return <div>Loading Data...</div>;
  }

  // console.log('gameState', gameState);
  const getButtonAction = () => {
    // console.log('AAAAAAACtion', 'prevQuestion', prevQuestion, 'gameState.questionId', gameState.questionId);

    if (prevQuestion === 'initial' && gameState.questionId && gameState.questionState === 'closed') {
      // setprevQuestion(gameState.questionId);
      return openQuestion;
    }

    // if (['closed', 'new'].includes(gameState.questionState)) {
    //   return prevQuestion && gameState.questionId && prevQuestion !== gameState.questionId
    //     ? openQuestion
    //     : nextQuestion;
    // } else if (gameState.questionState === 'open') {
    //   return closeQuestion;
    // }
    return nextQuestion;
  };

  const getQuestionMeanings = () => {
    if (gameState.questionState === 'open') {
      return 'Open (Attendees can answer question)';
    }
    if (gameState.questionState === 'closed') {
      return 'Closed (Attendees see the question results)';
    }
    return 'Waiting (Attendees see the home screen)';
  };

  const getButtonLabel = () => {
    // console.log('LLLLLABBBBEEEELLLLL', 'prevQuestion', prevQuestion, 'gameState.questionId', gameState.questionId);

    if (prevQuestion === 'initial' && gameState.questionId && gameState.questionState === 'closed') {
      return 'Open Question';
    }

    // if (['closed', 'new'].includes(gameState.questionState)) {
    //   return prevQuestion && gameState.questionId && prevQuestion !== gameState.questionId
    //     ? 'Open Question'
    //     : 'Next Question';
    // } else if (gameState.questionState === 'open') {
    //   return 'Close Question';
    // }
    return 'Next Question';
  };

  return (
    <div className="flex-center direction-column" style={{ height: 300, justifyContent: 'space-evenly' }}>
      {gameState.state !== 'ended' ? (
        <>
          {gameState.state === 'initial' ? (
            <Button variant="contained" onClick={startGame} sx={buttonStyle}>
              Start Game
            </Button>
          ) : (
            <h2>Question is: {getQuestionMeanings()}</h2>
          )}
          {questionIds.indexOf(gameState.questionId) + 1 >= questionIds.length &&
          gameState.questionState === 'closed' ? null : (
            <>
              <Button
                variant="contained"
                onClick={getButtonAction()}
                disabled={gameState.state !== 'inProgress'}
                sx={buttonStyle}
              >
                {getButtonLabel()}
              </Button>
              <br />
              <br />
            </>
          )}

          <Button
            variant="contained"
            onClick={endGame}
            disabled={gameState.state === 'initial'}
            sx={buttonStyle}
            color={'error'}
          >
            End Game
          </Button>
        </>
      ) : (
        <h2>Game has been completed</h2>
      )}

      <Button variant="contained" onClick={resetGame} sx={buttonStyle} color={'error'}>
        Archive & Reset
      </Button>
    </div>
  );
};

export default Controls;
